<div matDialogTitle>자동결제 수단 관리</div>

<div matDialogContent>
  <div class="auto-billing-dialog__status">
    @if (info) {
      <strong>자동결제 수단이 등록되어 있습니다.</strong>
      <span>등록된 결제 수단을 변경하거나 안전하게 해제할 수 있습니다.</span>
    } @else {
      <strong>등록된 자동결제 수단이 없습니다.</strong>
      <span>카드 또는 계좌를 등록하면 다음 결제를 간편하게 진행할 수 있습니다.</span>
    }
  </div>
</div>

<div matDialogActions>
  <div fxLayout="row" fxLayoutGap="20px">
    @if (info) {
      <button (click)="requestBillingKey('CARD')" mat-flat-button>결제 수단 변경</button>
      <button (click)="deleteBillingKey()" class="bg-warn" mat-flat-button>자동결제 해제</button>
    } @else {
      <button (click)="requestBillingKey('CARD')" mat-flat-button>카드 등록</button>
      <button (click)="requestBillingKey('TRANSFER')" mat-flat-button>계좌 등록</button>
    }
  </div>
</div>



